import { setSessionInfo } from 'actions';
import { connect } from 'react-redux';

import App from './App';

const mapStateToProps = (state) => ({
    session: state.session
});

const mapDispatchToProps = (dispatch) => ({
    setSessionInfo: (sessionInfo) => dispatch(setSessionInfo(sessionInfo))
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
